import React, {useState} from "react";
import { useNavigate } from "react-router-dom";

import { Container } from "../../styles/GlobalStyles";
import { Form, Button } from './styled';

import api from '../../api/axios';
import firebase from '../../firebaseConfig'
import { getAuth } from "firebase/auth"
import { signInWithEmailAndPassword } from "firebase/auth"

import { useDispatch } from "react-redux";
import * as actions from '../../store/modules/auth/actions';

export default function Login () {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');

        if (username == ''){ 
            setError('Usuário deve ser preenchido')
            return
        }
        if (password == ''){ 
            setError('Senha deve ser preenchida')
            return
        }
        
        try {
            const resp = await api.get('/user/findbyemail/' + username);

            if (!resp) {
                setError('Usuário inexistente');
                return;
            }

        } catch (error) {
            console.log(error)
            setError(error.response.data.error)
            //console.log(error.response)
            //console.log(error.message)
            //console.log('Erro -> ' + error);
        }

        try {
        const auth = getAuth(firebase);
        await signInWithEmailAndPassword(auth, username, password)
        
         dispatch(actions.loginRequest({ username, password }));

         navigate('/usuario');
        }
        catch(error) {
            let { code } = error;
            console.log(error)
            switch (code) {
                case "auth/invalid-email":
                    setError("Email inválido")
                    return
                case "auth/wrong-password":
                    setError("Senha incorreta")
                    return
                case "auth/user-not-found":
                    setError("Usuário não cadastrado")
                    return
                default:
                    setError(code)
                    return
            };
        }
    }
    return (
        <Container>
            <h1>Login</h1>
            <Form onSubmit={handleSubmit}>
                <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Seu email de usuario"/>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Sua senha"/>
                <div className="erro">{error ? error : ''}</div>
                <Button type="submit">Acessar</Button>
            </Form>
        </Container>
    );
}